exports.categoryParams = {
  urlPrefix: "/categorie-produit/",
};

exports.createCategories = async ({ graphql, actions }) => {
  const { createPage, createRedirect } = actions;
  const result = await graphql(
    `
      {
        categories: allStrapiCategory {
          edges {
            node {
              slug
              strapiParent {
                slug
              }
              strapiId
            }
          }
        }
      }
    `
  );

  if (result.errors) {
    throw result.errors;
  }

  const categories = result.data.categories.edges;
  const CategoryTemplate = require.resolve("./src/templates/category.js");
  const CategoryColorTemplate = require.resolve("./src/templates/category-color.js");

  categories.forEach((category, index) => {
    if (category.node.strapiParent && category.node.strapiParent.slug === "tote-bags-par-couleur")
      createPage({
        path: `${this.categoryParams.urlPrefix}${category.node.slug}`,
        component: CategoryColorTemplate,
        context: {
          ...category.node,
        },
      });
    else
      createPage({
        path: `${this.categoryParams.urlPrefix}${category.node.slug}`,
        component: CategoryTemplate,
        context: {
          ...category.node,
        },
      });

    // Redirection racine catégorie : /{slug} → /categorie-produit/{slug}
    // (même logique que node-product.js) — rattrape les anciennes URLs
    // catégorie à la racine tombées en 404. Sans `force` : une vraie page
    // à /{slug} reste prioritaire.
    createRedirect({
      fromPath: `/${category.node.slug}`,
      toPath: `${this.categoryParams.urlPrefix}${category.node.slug}`,
      isPermanent: true,
      redirectInBrowser: true,
    });
  });
};
